/* RunNowComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RunNowRenderer");
const Registrations = require("../../../../../../RegistrationNamespaces");
const _ = require("lodash");

class RunNowComponent extends EventEmitter {
    constructor(osPlanDetailsViewModel) {
        super();
        this._osPlanDetailsViewModel = osPlanDetailsViewModel;
        this._logger = this._osPlanDetailsViewModel._logger;
        this._gameEditor = this._osPlanDetailsViewModel._gameEditor;
        //this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.planEntity;
        this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.getPlan();
        this._modalUserFeedback = this._osPlanDetailsViewModel._modalUserFeedback;
        this._userSession = this._osPlanDetailsViewModel._userSession;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "RunNowComponent.shutdown() error.");
            }
        );
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    sendResponse(result) {
        this._context.resolve(result);
    }
    cancelAction() {
        this._context.reject({userRejected: true});
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    startPlan(/*workInput*/) {
        // Disable the buttons and hide the veil.
        // Once workId is available, switch the screen to results
        const progressCB = ({workId}) => {
            const renderer = _.get(this, "_osPlanDetailsViewModel._renderer");
            if (renderer) {
                renderer._disableAllViewActions();
                renderer._setViewActionText("RunNowPlan", "Running...");
            }
            if (workId && this._gameEditor._runWorkId !== workId) {
                this._gameEditor._runWorkId = workId;
                // Case 24163 - Delay to make sure the result entity is ready before switching to result view
                _.delay(() => {
                    this._modalUserFeedback.hideDisplayed();
                    this._gameEditor.setActiveView(Registrations.OS_PLAN_EDITOR_VIEW_RESULTS);
                }, 2000);
            }
        };

        // Show progress veil before running the work
        if (this._modalUserFeedback) {
            this._modalUserFeedback.displayLoading({
                message: "Running your plan... This could take a moment",
            });
        }

        // Run the work with progressCB as the callback function
        return this._osPlanEntity.runPlanWork({}, progressCB).catch((err) => {
            this._logger.warn({error: err}, "RunAction.run() - Error");
            return this._modalUserFeedback.displayError({error: {errorMsg: err}});
        });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = RunNowComponent;
